export default __webpack_public_path__ + "static/media/ion-ios-musical-notes.a67050b5.svg";